import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import CommandJobsContainer from './Components/CommandJobsContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';

const CommandJobsMain = () => (
  <PageContainer pageName="command-jobs">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_COMMAND_JOBS}>
      <CommandJobsContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default CommandJobsMain;
